module.exports = __webpack_public_path__ + "img/fugitive-telemetry.9aa21b12.png";